import { stepConfigItem } from './types';

const stepsSchemaEn: stepConfigItem[] = [
  {
    id: 'dietType',
    slug: 'diet-type',
  },
  {
    id: 'weightValue',
    slug: 'weight',
    shouldBackendValidate: true,
  },
  {
    id: 'dietMode',
    slug: 'diet-mode',
    fork: {
      chooseChild: (state: { dietMode: string }) =>
        state.dietMode !== 'stabilization' ? 'goalWeight' : 'activityLevel',
      children: {
        goalWeight: [
          { id: 'goalWeightValue', slug: 'goal-weight', shouldBackendValidate: true },
          { id: 'activityLevel', slug: 'activity-level' },
          { id: 'sex', slug: 'sex' },
          { id: 'dateOfBirth', slug: 'birth-date', shouldBackendValidate: true },
          { id: 'heightValue', slug: 'height', shouldBackendValidate: true },
          { id: 'summary', slug: 'summary' },
        ],
        activityLevel: [
          { id: 'activityLevel', slug: 'activity-level' },
          { id: 'sex', slug: 'sex' },
          { id: 'dateOfBirth', slug: 'birth-date', shouldBackendValidate: true },
          { id: 'heightValue', slug: 'height', shouldBackendValidate: true },
          { id: 'summary', slug: 'summary' },
        ],
      },
    },
  },
];

export default stepsSchemaEn;
